import $ from "jquery";
import { AimWarn } from "#scripts/tools/aimlog.js";
import { campaignsFront } from "#templates/modules/campaigns";
import { newslistFront } from "#templates/modules/newslist";
import { categoriesFront } from "#templates/modules/categorylisting";
import { cardsFront } from "#templates/modules/cardlisting";
import { buttonRowFront } from "#templates/modules/buttonrow";
import { calendarModule } from "#templates/modules/calendar";
import { eventsModule } from "#templates/modules/events";
import { renholdFront } from "#templates/modules/renhold";
import { rekPredictions } from "#templates/modules/rek-predictions";

export const compileContent = (_html, data) => {
	let html = $(`<div>${_html}</div>`);
	const includedRelatedContent = data.relatedContentObjects;
	html.find(".h-card").unwrap();

	html.find("span#editorBlokk > span").each(function () {
		const id = $(this).attr("id") || false;
		const that = $(this);
		if (id) {
			$.each(includedRelatedContent, (nr, obj) => {
				if (obj.contentId === id) {
					let html = $(`<div class="blokk" data-id="${obj.contentId}" data-author="${obj.creator}"></div>`);
					if (obj.pageTypeId === "mal_blokk") {
						if (obj.contentId === "dbab27c4-7c5d-4ef4-a6c7-941bbc62e85e") {
							// Forced template;
							// const tContainer = testimonialContainer(obj);
							// html.append(tContainer);
						} else {
							html.append(decodeURIComponent(obj.contentObject));
							// html.append(obj.contentObject);
						}
					} else if (obj.pageTypeId === "mal_dynamisk") {
						const dynamicMeta = JSON.parse(decodeURIComponent(obj.metaObject));

						if (dynamicMeta.id === "17c15981-758d-4d09-a7ee-b2d47d2af6f0") {
							// const topimageHtml = topimage(obj, dynamicMeta);
							// html.append(topimageHtml);
						} else if (dynamicMeta.id === "cd3957ad-61cc-4580-a458-e62039fb4bad") {
							// let ref = testimonial(dynamicMeta, obj);
							// html.append(ref);
						} else if (dynamicMeta.id === "6d0c6d38-e11d-4606-8550-d3ca77ae1ca0") {
							// const service = services(obj, dynamicMeta);
							// html.append(service);
						} else {
							console.warn("no template", dynamicMeta);
							AimWarn("No template", dynamicMeta);
						}
					}

					if (obj.relatedContentObjects) {
						if (obj.relatedContentObjects.length > 0) {
							const children = compileContent(html.prop("outerHTML"), obj);
							html = children;
						}
					}
					that.parent().replaceWith(html);
				}
			});
		}
	});

	html.find("a[href*='aim:']").each(function () {
		$(this).attr("href", $(this).attr("href").replace("aim:", "/artikkel/"));
	});
	html = html.prop("outerHTML");
	if (html.match(/\[split:(.|\n)*\]/gim)) {
		for (const me of html.match(/\[split:(.|\n)*\]/gim)) {
			let split = me.replace("[split:</p>", "").replace("<p>]", "");
			if (split.match("<p>||</p>")) {
				split = split.split(/<p>\|\|<\/p>/gim);
				if (split.length > 1) {
					let cols = [];
					for (const col of split) {
						cols.push(`
                        <div class="col">
                            ${col}
                        </div>
                        `);
					}
					cols = cols.join("");
					const row = `
                    <div class="row row-eq-height">
                        ${cols}
                    </div>`;
					html = html.replace(me, row);
				}
			}
		}
	}
	html = compileModules(html);

	return html;
};

export const compileModules = (html) => {
	let resultHtml = html;
	if (resultHtml.match(/\[modul:.+?\]/gim)) {
		for (const me of resultHtml.match(/\[modul:.+?\]/gim)) {
			const modulename = me.replace("[modul:", "").replace("]", "");
			let moduleParams = "";
			let moduleHtml = "";
			let maxItems = "";
			if (modulename === "stepguide") {
				// moduleHtml = stepguide;
			} else if (modulename.match("nyhetliste:")) {
				moduleParams = modulename.replace("nyhetliste:", "").split(":");
				maxItems = moduleParams[0];
				const moduleTitle = moduleParams[1];
				const moduleMoreText = moduleParams[2] ? moduleParams[2] : "";
				moduleHtml = newslistFront(null, maxItems, moduleTitle, moduleMoreText);
			} else if (modulename.match("cardlist:")) {
				moduleParams = modulename.replace("cardlist:", "").split(":");
				maxItems = moduleParams[0];
				const moduleCategory = moduleParams[1];
				const moduleTitle = moduleParams[2];
				const moduleCardDesign = moduleParams[3] ? moduleParams[3] : "";
				const moduleMoreText = moduleParams[4] ? moduleParams[4] : "";
				const moduleMoreLink = moduleParams[5] ? moduleParams[5] : "";
				moduleHtml = cardsFront(moduleCategory, maxItems, moduleTitle, moduleMoreText, moduleMoreLink, moduleCardDesign);
			} else if (modulename.match("categorylist:")) {
				moduleParams = modulename.replace("categorylist:", "").split(":");
				const moduleMoreText = moduleParams[0];
				const moduleLessText = moduleParams[1] ? moduleParams[1] : "";
				const moduleCardDesign = moduleParams[2] ? moduleParams[2] : "";
				moduleHtml = categoriesFront(moduleMoreText, moduleLessText, moduleCardDesign);
			} else if (modulename.match("kampanje:")) {
				const moduleParams = modulename.replace("kampanje:", "").split(":");
				maxItems = moduleParams[0];
				const moduleCardItemGuid = moduleParams[1] ? moduleParams[1] : "";
				const moduleCardDesign = moduleParams[2] ? moduleParams[2] : "";
				moduleHtml = campaignsFront(maxItems, moduleCardItemGuid, moduleCardDesign);
			} else if (modulename.match("kalender:")) {
				moduleParams = modulename.replace("kalender:", "");
				maxItems = moduleParams.split(":", 3)[0];
				const mode = moduleParams.split(":", 3)[1];
				const moduleTitle = moduleParams.split(":", 3)[2];
				const moduleLinks = moduleParams.slice(moduleParams.indexOf(moduleTitle) + moduleTitle.length + 1);
				moduleHtml = calendarModule(maxItems, moduleTitle, mode, moduleLinks);
			} else if (modulename.match("kalender_sub:")) {
				moduleParams = modulename.replace("kalender_sub:", "");
				maxItems = moduleParams.split(":", 4)[0];
				const mode = moduleParams.split(":", 4)[1];
				const category = moduleParams.split(":", 4)[2];
				const moduleTitle = moduleParams.split(":", 4)[3];
				const moduleLinks = moduleParams.slice(moduleParams.indexOf(moduleTitle) + moduleTitle.length + 1);
				moduleHtml = calendarModule(maxItems, moduleTitle, mode, moduleLinks, category);
			} else if (modulename.match("events:")) {
				moduleParams = modulename.replace("events:", "");
				maxItems = moduleParams.split(":", 3)[0];
				const mode = moduleParams.split(":", 3)[1];
				const moduleTitle = moduleParams.split(":", 3)[2];
				const moduleLinks = moduleParams.slice(moduleParams.indexOf(moduleTitle) + moduleTitle.length + 1);
				moduleHtml = eventsModule(maxItems, moduleTitle, mode, moduleLinks);
			} else if (modulename.match("skjema:")) {
				let skjema = "kontakt";
				if (modulename.match(":")) {
					const splitM = modulename.split(":");
					skjema = splitM[1];
				}
				if (skjema === "bestilling") {
					// moduleHtml = checkAdress;
				} else if (skjema === "kontakt") {
					// moduleHtml = contact();
				}
			} else if (modulename.match("beredskapsmelding:")) {
				// moduleHtml = warningsFront();
			} else if (modulename.match("knapperad:") || modulename.match("knapperad_wide:")) {
				let className = "";
				moduleParams = modulename.replace("knapperad:", "");
				if (modulename.match("knapperad_wide")) {
					moduleParams = modulename.replace("knapperad_wide:", "");
					className = "utfallende";
				}
				const buttons = moduleParams;
				moduleHtml = buttonRowFront(buttons, className);
			} else if (modulename.match("some:")) {
				const some = modulename.replace("some:", "");
				const someType = some.slice(0, some.indexOf(":"));
				const someLink = some.slice(some.indexOf(":") + 1);
				moduleHtml = `<div class="some"><a href="${someLink}" ><img src="/images/some/${someType}.svg" width="44" height="44" alt="${someType}"></img></a></div>`;
			} else if (modulename.match("renhold:")) {
				const kommuneNr = modulename.replace("renhold:", "");
				moduleHtml = renholdFront(kommuneNr);
			} else if (modulename.match("rek:predictions:")) {
				moduleParams = modulename.replace("rek:predictions:", "");
				maxItems = GetModuleParam(moduleParams, 1, "5");
				const mode = GetModuleParam(moduleParams, 2, "pill");
				const moduleTitle = GetModuleParam(moduleParams, 3, "");
				let options = GetModuleParam(moduleParams, 4, "");

				// moduleParams = moduleParams.replace(/\{[^{}]*\}/g, (match) => {
				// 	return `${match.replace(/:/g, ";")}`;
				// });
				if (options !== "") {
					const parts = options.split(/[,{}]/).map(part => part.trim()).filter(part => part);

					const tempModuleParams = parts.map(part => {
						const [key, value] = part.split(';').map(str => str.trim());
						return `"${key}": "${value}"`;
					}).join(', ');
					if (tempModuleParams !== undefined) {
						options = `{${tempModuleParams}}`;
					}
				}

				moduleHtml = rekPredictions(maxItems, moduleTitle, mode, options);
			} else {
				moduleHtml = "";
				console.warn("no module", modulename);
				AimWarn("No module", modulename);
			}
			resultHtml = resultHtml.replace(me, moduleHtml);
		}
	}
	return resultHtml;
};

const GetModuleParam = (moduleParams, argnumber, defaultValue = "") => {
	if (argnumber < 1) return defaultValue; // Handle invalid argnumber
	const paramsArray = moduleParams.split(":");
	return paramsArray.length >= argnumber ? paramsArray[argnumber - 1] : defaultValue;
};
